export const getMpiElement = (state: any) => state.mpiElement.mpiElement;
